import { Outlet } from 'react-router-dom'

const TokenRequest = () => <Outlet />

export default TokenRequest
